import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativeHoursBetween32and45FMAY: typeof valueTypeRenderers.chillCumulativeHoursBetween32and45FMAY =
  {
    label: () => unitConverter.chillCumulativeHoursBetween32and45FMAY().title(),
    point: () =>
      makeNumberRenderer({
        baseLabel: unitConverter.chillCumulativeHoursBetween32and45FMAY().title(),
        render: (n) => unitConverter.chillCumulativeHoursBetween32and45FMAY(n).valueAsString(),
      }),
  }
